import styled from "styled-components";

export const MoreTemplates = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  display: grid;
  grid-template-areas:
    "HD"
    "CT";
  grid-template-rows: 56px auto;
  background: ${(props) => props.theme.colors.mainBg};
`;

export const ContentNavigation = styled.section<any>`
  width: 100%;
  height: 60px;
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 20px;
  background: ${(props) =>
    props.headerBg === "main"
      ? props.theme.colors.mainBg
      : props.theme.colors.white};
`;

export const ContentsSection = styled.section<any>`
  grid-area: CT;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding: ${(props) => (props.padding ? props.padding : "16px")};
  background: ${(props) => (props.background ? props.background : "none")};
  gap: ${(props) => (props.gap ? props.gap : "40px")};
`;
